import styled from 'styled-components';
import { size } from 'styled-manila';
import { getColor } from 'core/utils/Styles';

export const Label = styled.label`
	position: relative;
	width: 100%;
	padding: 0;
	margin-top: 10px;
	display: flex;
	align-items: center;
`;

export const Text = styled.span`
	display: block;
	font-size: 8px;
	line-height: 1;
	font-weight: 700;

	@media (min-width: 500px) {
		font-size: 9px;
	}
`;

export const Indicator = styled.div`
	display: block;
	min-width: 16px;
	flex-basis: 16px;
	${size(16)};
	margin-right: 5px;
	background-color: ${getColor('porcelain')};
	background-position: center center;
	background-repeat: no-repeat;
	border: 1px solid ${getColor('gray8')};
	border-radius: 2px;
`;

export const Check = styled.input.attrs({ type: 'checkbox' })`
	display: none;

	/* stylelint-disable */
	&:checked ~ ${Indicator} {
		color: ${getColor('white')};
		background-color: ${getColor('offGreen')};
		border: 1px solid ${getColor('primaryBrand')};
	}

	&:active ~ ${Indicator} {
		color: ${getColor('white')};
		background-color: ${getColor('offGreen')};
	}

	&:checked ~ ${Indicator} {
		background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIxMnB4IiBoZWlnaHQ9IjExcHgiIHZpZXdCb3g9IjAgMCAxMiAxMSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4NCiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQwICgzMzc2MikgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+DQogICAgPHRpdGxlPkltcG9ydGVkIExheWVycyBDb3B5PC90aXRsZT4NCiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4NCiAgICA8ZGVmcz48L2RlZnM+DQogICAgPGcgaWQ9IkRlc2t0b3AtRmxvdyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4NCiAgICAgICAgPGcgaWQ9IjItQ2hlY2tvdXQtR2lmdGluZy1BdXRvUmVuZXciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zOC4wMDAwMDAsIC0xMjAuMDAwMDAwKSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9IiMzOEJGQzMiPg0KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM1LjAwMDAwMCwgMTE2LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJDaGVja2JveC1hY3RpdmUiPg0KICAgICAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IkltcG9ydGVkLUxheWVycy1Db3B5IiBwb2ludHM9IjE0IDUgNy40NjYyNTc2NyAxMy41Mjc2MDc0IDQgMTAuMDYxMzQ5NyI+PC9wb2x5bGluZT4NCiAgICAgICAgICAgICAgICA8L2c+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4NCg==');
		background-size: 82%;
		background-position-y: 1px;
	}
	/* stylelint-enable */
`;
